import classes from "../../PaymentMethods.module.scss";
import type { WalletButtonProps } from "@/payment/types";

export function BraintreeCreditCardButton(props: Readonly<WalletButtonProps>) {
  // amount and onError are part of WalletButtonProps but not needed at the
  // selection stage — the card details form handles actual charging.
  const { onSuccess } = props;

  return (
    <button
      type="button"
      onClick={() => onSuccess({})}
      className={classes.button}
    >
      <span>Credit/debit card</span>
      <svg
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        className={classes.creditCardIcon}
      >
        <path d="M14.5 2.25H1.497a1.5 1.5 0 0 0-1.5 1.5l.002 8a1.5 1.5 0 0 0 1.5 1.5h13.005a1.5 1.5 0 0 0 1.5-1.5l-.002-8a1.5 1.5 0 0 0-1.5-1.5m-13.004 1h13.005a.5.5 0 0 1 .5.5v.75H.996v-.75a.5.5 0 0 1 .5-.5m13.007 9H1.498a.5.5 0 0 1-.5-.5L.996 6.5h14.005l.002 5.25a.5.5 0 0 1-.5.5"></path>
        <path d="M6 10a.5.5 0 0 1 0 1H3a.5.5 0 0 1 0-1zM5 8.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1 0-1z"></path>
      </svg>
    </button>
  );
}
